import { render, staticRenderFns } from "./GerkViewLink.vue?vue&type=template&id=7d46b14b&"
import script from "./GerkViewLink.vue?vue&type=script&lang=js&"
export * from "./GerkViewLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports